// extracted by mini-css-extract-plugin
export default {"container":"Authorization_container__PubSR"};